export default "__VITE_ASSET__CAtLdCJ6__"